import { render } from "./ShiftList.vue?vue&type=template&id=3c7bc43e&scoped=true"
import script from "./ShiftList.vue?vue&type=script&lang=js"
export * from "./ShiftList.vue?vue&type=script&lang=js"

import "./ShiftList.vue?vue&type=style&index=0&id=3c7bc43e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7bc43e"]])

export default __exports__